import PropTypes from 'prop-types'
import styled from 'astroturf/react'
import { useEffect } from 'react'
import { useFlag } from '@calendly/feature-check-react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
const spacing1_25x = 'var(--spacing-1-25x, 1.25rem)'
const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'

import { resetTheme } from 'initializers/theme'
import { useFeatures } from 'components/use_organization'
import Branding from 'components/branding'
import _StyledContainer from "container-StyledContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/layout/container.js?styleId=StyledContainer";


const StyledContainer = /*#__PURE__*/styled('div', null, {
  displayName: "StyledContainer",
  styles: _StyledContainer
})

const Container = ({
  children,
  expanded = false,
  hiddenSidebar = false,
  hideBranding = false,
  fitContent = false,
  ...props
}) => {
  const { data } = useFeatures()
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  const isPhone = useDeviceType('isPhone')
  const isTabletUp = useDeviceType('isTabletUp')
  const isTabletDown = useDeviceType('isTabletDown')
  const isDesktopUp = useDeviceType('isDesktopUp')

  useEffect(() => {
    if (data) {
      const { custom_theme_allowed: customThemeAllowed } = data
      if (!customThemeAllowed) {
        resetTheme()
      }
    }
  }, [data])

  return (
    <StyledContainer
      {...props}
      expanded={expanded}
      hiddenSidebar={hiddenSidebar}
      fitContent={fitContent}
      bookingAppRedesign={bookingAppRedesign}
      isPhone={isPhone}
      isTabletUp={isTabletUp}
      isTabletDown={isTabletDown}
      isDesktopUp={isDesktopUp}
      data-id="layout-container"
      data-container="booking-container"
    >
      {!hideBranding && <Branding />}
      {children}
    </StyledContainer>
  )
}

Container.propTypes = {
  expanded: PropTypes.bool,
  hiddenSidebar: PropTypes.bool,
  hideBranding: PropTypes.bool,
  fitContent: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

export default Container
